export default ((
{ colorRGB, usedVideosCount, quota



}) => {
  const opacity = usedVideosCount / quota;

  return `rgba(${colorRGB.join(',')}, ${opacity})`;
});